import axios from 'axios'
import util from "@/util/util"

let loading;

const request = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 1000*60*20 // 请求超时时间
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密

request.interceptors.request.use(config => {
  util.log("env",process.env.NODE_ENV)
  if (process.env.NODE_ENV === 'production') {
    config.baseURL = "https://server.shenkatd.cn"
  } else {
    config.baseURL = "http://localhost:9001"
  }
  config.headers['Content-Type'] = 'application/json;charset=utf-8';
  let token = localStorage.getItem("token")
  util.log("token",token)
  config.headers['token'] = token;  // 设置请求头

  return config
}, error => {
  return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  response => {
    let res = response.data
    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      return res
    }
    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      res = res ? JSON.parse(res) : res
    }
    return res
  },
  error => {
    console.log('err ---' + error) // for debug
    return Promise.reject(error)
  }
)

export default request
